import React from 'react';
import { Create } from 'react-admin';
import TipoProyectoForm from '../TipoProyectoForm';

function TipoProyectoCreate(props) {
  return (
    <Create {...props}>
      <TipoProyectoForm redirect="list" />
    </Create>
  );
}

export default TipoProyectoCreate;
